module.exports = __webpack_public_path__ + "static/img/samajuri (16).18bde09.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/samajuri/samajuri (16).jpg
// module id = Sbak
// module chunks = 0